/* ========================================================================== *\
	IMPORTS
\* ========================================================================== */

import { isEmpty } from 'lodash';

import { ExamSelect } from './select';
import { Exam } from './exam';


import { publish } from '../../01-helpers/event-manager';
import { EXAM_LOADED } from '../../02-const/event-names';

import getQuestions from '../../03-api/golfexam/get-questions';

/* == IMPORTS =============================================================== */



/* ========================================================================== *\
	PRIVATE VARIABLES
\* ========================================================================== */

const
    moduleName = 'exam-widget',
    baseCssClass = `js-${moduleName}`,

    cssClasses = {
        hidden: 'hidden'
    },
    selectors = {
        base: `.${baseCssClass}`,
        exam: `.${baseCssClass}-exam`,
        select: `.${baseCssClass}-select`
    },
    settings = {
        baseElement: document.querySelector(selectors.base),
        examInstance: null,
        typeInstance: null
    };

/* == PRIVATE VARIABLES ===================================================== */



/* ========================================================================== *\
	PRIVATE METHODS
\* ========================================================================== */

function handlerExamSelected(typeId, ruleId, name, nameRule) {
    startExam(typeId, ruleId, name, nameRule);
}

function hideType() {
    document.querySelector(selectors.select).classList.add(cssClasses.hidden);
}

function initExam() {
    const
        examElement = document.querySelector(selectors.exam);

    if (examElement === null) {
        return;
    }

    const
        exam = new Exam(examElement);

    return exam;
}

function initType() {
    const
        selectElement = document.querySelector(selectors.select);

    if (selectElement === null) {
        return;
    }

    const
        examSelect = new ExamSelect(selectElement);

    examSelect.onExamSelected(handlerExamSelected);
    publish(EXAM_LOADED);
}

function showExam() {
    document.querySelector(selectors.exam).classList.remove(cssClasses.hidden);
}

async function startExam(typeId, ruleId, name, nameRule) {
    const
        questions = await getQuestions(typeId, ruleId);

    if (!isEmpty(questions)) {
        settings.examInstance.startExam(questions, name, nameRule);
        hideType();
        showExam();
    }
}

/* == PRIVATE METHODS ======================================================= */



/* ========================================================================== *\
	EVENT HANDLING
\* ========================================================================== */


/* == EVENT HANDLING ======================================================== */



/* ========================================================================== *\
	INITIALIZATION
\* ========================================================================== */


function init() {
    if (settings.baseElement === null) {
        return;
    }

    settings.examInstance = initExam();
    settings.typeInstance = initType();
}

init();

/* == INITIALIZATION ======================================================== */
